import { Component, Input } from '@angular/core';
import { DetailInfo } from 'common/model';
import {
  displayValueForRawCell,
  parseRepeatableTableColumns
} from 'shared/shared.helper';

// One resolved row of display strings, aligned to `columnTitles`.
type DisplayRow = string[];

/**
 * Read-only renderer for a saved RepeatableTable field on the detail/view screens
 * (registration details, contact detail, etc.). Expects the DetailInfo to have been hydrated
 * via assignDetailInfoValue (detailInfo.key = the saved tableRows). Resolves each cell to
 * display text (option labels, formatted dates, Yes/No) through the column definitions.
 */
@Component({
  selector: 'app-detail-info-table-view',
  templateUrl: './detail-info-table-view.component.html',
  standalone: false
})
export class DetailInfoTableViewComponent {
  public columnTitles: string[] = [];
  public rows: DisplayRow[] = [];

  @Input() set detailInfo(value: DetailInfo) {
    this.columnTitles = [];
    this.rows = [];
    if (!value) {
      return;
    }

    const columns = parseRepeatableTableColumns(value);
    const fields = columns.reduce<DetailInfo[]>((acc, c) => acc.concat(c.fields || []), []);
    this.columnTitles = columns.map((c) => c.title);

    const savedRows: any[][] = Array.isArray(value.key) ? (value.key as unknown as any[][]) : [];
    this.rows = (savedRows || []).map((rowCells) =>
      fields.map((field) => displayValueForRawCell(field, rowCells || []))
    );
  }
}
